<template>
  <div class="page-companies">
    <Overlay width="x-small" :autoHeight="true" :link="{name: 'companies'}">
      <Notification
        :withinOverlay="true"
        v-if="notification.active"
        :content="notification.content"
        :type="notification.type"/>

      <CompanyForm
        v-model="company"
        @submit="submit"
        :errors="errors"
        :users="usersOptions"
      />
    </Overlay>
  </div>
</template>

<script>
import page from '@/mixins/page'
import notification from '@/mixins/notification'

import {mapActions, mapState} from 'vuex'

import {createCompanyData} from '@/lib/companies'

import CompanyForm from '@/components/forms/CompanyForm'
import Overlay from '@/components/Overlay'

export default {
  name: 'companies',

  mixins: [page, notification],

  props: {
    per_page: {
      default: 10
    },

    page: {
      default: 1
    }
  },

  components: {
    CompanyForm,
    Overlay
  },

  data() {
    return {
      company: {},
      errors: {},
      title: 'New Company'
    }
  },

  computed: {
    ...mapState(['companies', 'currentUser']),

    usersOptions() {
      const user = this.currentUser

      return [
        {
          key: user.email,
          value: user.id
        }
      ]
    },

    pagination() {
      return {
        page: this.page,
        perPage: this.per_page
      }
    }
  },

  methods: {
    ...mapActions(['createCompany']),

    submit() {
      createCompanyData(this.company)
        .then(({data}) => {
          this.triggerNotification('success', 'company', 'created')

          window.setTimeout(() => {
            this.$router.push({name: 'websites', params: {companyId: data.id}})
          }, this.closeDelay)
        })
        .catch(({response}) => {
          this.errors = response.errors
        })
    }
  }
}
</script>
